module.exports = __webpack_public_path__ + "img/product-shoes.225fb533.jpg";